export default __webpack_public_path__ + "static/media/ico-s3-score-low.188ff1dd.svg";